(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-wrist-measuring-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const openButton = event.target.closest('[data-sf-wrist-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.sfWristOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-sf-wrist-close]');
    if (closeButton) {
      closeButton.closest('dialog').close();
      return;
    }
    if (event.target.matches('dialog.sf-wrist-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-wrist-size-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-product-measurements')) {
    customElements.define('sf-product-measurements', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.variantSpecific !== 'true') return;
        this.controller = new AbortController();
        const json = this.querySelector('[data-sf-measure-variants]');
        this.measures = json ? JSON.parse(json.textContent) : {};
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const form = document.getElementById(this.getAttribute('form-id'));
          form?.addEventListener('variant:changed', (event) => {
            const item = this.measures[String(event.detail?.variant?.id)] || {};
            const measure = this.querySelector('[data-sf-measure]');
            const note = this.querySelector('[data-sf-measure-note]');
            measure.textContent = item.summary || '';
            measure.hidden = !item.summary;
            note.textContent = item.note || '';
            note.hidden = !item.summary || !item.note;
          }, {signal: this.controller.signal});
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
